import { createFcmExperimentsContext } from 'src/app/shared/contexts/experiment';
import type { LoadedStateData } from 'src/app/shared/utils/async';

import {
	EXPERIMENT_STARFISH_SAP_VERSION_3,
	EXPERIMENT_SUPPORTER_TO_STARTER_RECOMMENDATIONS_ENABLED,
	FCM_EXPERIMENT_PSF_TO_SAP_LOCAL_FLOW,
	FCM_EXPERIMENT_SALP_PERSONAL_STORY_TOGGLE,
	FCM_EXPERIMENT_STARFISH_PETITION_KICKSTART_TOGGLE,
	FCM_EXPERIMENT_SUNRISE_FOUNDATIONS_EXPERIENCE,
} from './config';

export const {
	FcmExperimentsContext: StartAPetitionPageFcmExperimentsContext,
	FcmExperimentsProvider: StartAPetitionPageFcmExperimentsContextProvider,
	useFcmExperiments: useStartAPetitionPageFcmExperiments,
	useAsyncFcmExperiments: useAsyncStartAPetitionPageFcmExperiments,
	prefetchFcmExperiments: prefetchStartAPetitionPageFcmExperiments,
} = createFcmExperimentsContext({
	name: 'StartAPetitionPageFcmExperimentsContext',
	dataProperty: 'pageFcmExperiments',
	configs: {
		psfToSapLocalFlowExperiment: FCM_EXPERIMENT_PSF_TO_SAP_LOCAL_FLOW,
		petitionKickStartToggleExperiment: FCM_EXPERIMENT_STARFISH_PETITION_KICKSTART_TOGGLE,
		sunriseRethemeToggle: FCM_EXPERIMENT_SUNRISE_FOUNDATIONS_EXPERIENCE,
		salpPersonalStoryToggleExperiment: FCM_EXPERIMENT_SALP_PERSONAL_STORY_TOGGLE,
		supporterToStarterRecommendationsEnabledExperiment: EXPERIMENT_SUPPORTER_TO_STARTER_RECOMMENDATIONS_ENABLED,
		startAPetitionV3EnabledExperiment: EXPERIMENT_STARFISH_SAP_VERSION_3,
	},
	prefetch: true,
});

export type StartAPetitionPageFcmExperimentsState = ReturnType<typeof useAsyncStartAPetitionPageFcmExperiments>;
export type StartAPetitionPageFcmExperiments = LoadedStateData<StartAPetitionPageFcmExperimentsState>;
